// App.js
import React, { useState, useRef } from "react";
import * as tf from "@tensorflow/tfjs";

function TestingOcancerImages() {
  const [imageSrc, setImageSrc] = useState(null);
  const canvasRef = useRef(null);
  const imageRef = useRef(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageSrc(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const processImage = async () => {
    const imgElement = imageRef.current;
    let imageTensor = tf.browser.fromPixels(imgElement, 1); // Grayscale, shape [height, width, 1]

    // Normalize the image tensor to [0, 1]
    imageTensor = imageTensor.div(255.0);

    // Define Sobel kernels
    const sobelX = tf.tensor3d(
      [
        [[-1], [0], [1]],
        [[-2], [0], [2]],
        [[-1], [0], [1]],
      ],
      [3, 3, 1]
    );
    const sobelY = tf.tensor3d(
      [
        [[-1], [-2], [-1]],
        [[0], [0], [0]],
        [[1], [2], [1]],
      ],
      [3, 3, 1]
    );

    // Apply convolutions
    let edgesX = tf.conv2d(
      imageTensor.expandDims(2),
      sobelX.expandDims(3),
      [1, 1],
      "same"
    );
    let edgesY = tf.conv2d(
      imageTensor.expandDims(2),
      sobelY.expandDims(3),
      [1, 1],
      "same"
    );

    // Apply ReLU to clip negative values (though Sobel can have negatives, this "fixes" by taking positive gradients)
    edgesX = tf.relu(edgesX);
    edgesY = tf.relu(edgesY);

    // Compute magnitude
    const magnitude = tf.sqrt(tf.add(tf.square(edgesX), tf.square(edgesY)));

    // Normalize magnitude to [0, 1]
    const minVal = magnitude.min();
    const maxVal = magnitude.max();
    const normalized = magnitude.sub(minVal).div(maxVal.sub(minVal).add(1e-5));

    // Apply sigmoid to enhance contrast and "fix" the tracing
    const sigmoidal = tf.sigmoid(normalized.mul(5)); // Multiply by 5 for steeper sigmoid curve

    // Threshold to create binary wireframe (e.g., 0.5)
    const binary = tf.greater(sigmoidal, 0.5).toFloat();
    // Draw the result on canvas
    const canvas = canvasRef.current;
    await tf.browser.toPixels(binary.squeeze([3]), canvas); // Squeeze channel dim
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h1>Tree Wireframe Tracing App</h1>
      <form>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
      </form>
      {imageSrc && (
        <>
          <h2>Original Image</h2>
          <img
            ref={imageRef}
            src={imageSrc}
            alt="Uploaded"
            style={{ maxWidth: "400px" }}
          />
          <br />
          <button onClick={processImage}>Trace Wireframe</button>
          <h2>Wireframe Tracing</h2>
          <canvas ref={canvasRef} style={{ border: "1px solid black" }} />
        </>
      )}
    </div>
  );
}

export default TestingOcancerImages;
